module.exports = __webpack_public_path__ + "static/backcover-d811fbf6bfe74fa655bc8cbf36b89f56.jpg";